import * as util from "lib/util.js";
import { Router } from "@vaadin/router";
import {
  LitElement,
  TemplateResult,
  property,
  customElement,
  css,
} from "lit-element";
import { html, render } from "lit-html";
import { storeInstance } from "store/index.js";
import "mil-intersection-observer";
import "@vaadin/vaadin-split-layout/vaadin-split-layout.js";
import "./kb-toc.js";
import "./kb-topic-infinite.js";

class KbHelpsetInfinite extends LitElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.subscription = storeInstance.subscribe((state) => {
      this.stateChange(state);
    });
    this.state = storeInstance.state;
    this.string = this.state.strings;
    this._topicsArray = [];
    this.addEventListener(
      "tocItemClicked",
      this._handleTocItemClicked.bind(this)
    );
    this.addEventListener(
      "topicLinkClicked",
      this._handleTocTopicLinkClicked.bind(this)
    );
    this.addEventListener(
      "topicScrolledIntoPrimaryView",
      this._handleTopicScrolledIntoView.bind(this)
    );
    this.addEventListener("scrollHelpsetBy", this._scrollHelpsetBy.bind(this));
    this.scrollPos = 0;
    this.scrollDirection = "START";

    if (this.state.item) {
      this.refreshData();
    }
  }

  _scrollHelpsetBy(e) {
    if (!this.rightside) {
      this.rightside = this.shadowRoot.querySelector("#rightside");
    }
    if (this.rightside && e.detail > 0) {
      this.rightside.scrollTop = e.detail;
    }
  }

  refreshData() {
    storeInstance.dispatch("getHelpsetTOC", {
      externalId: this.state.item.item.externalId,
      langCode: this.state.langCode,
    });
  }

  disconnectedCallback() {
    storeInstance.unsubscribe(this.subscription);
  }

  stateChange(state) {
    this.state = state;
    this.string = this.state.strings;
    if (this.state.item_toc) {
      if (!this.rootnode) {
        this.kbrid = this.kbrid
          ? this.kbrid
          : this._recurseToHREF(this.state.item_toc[0]); //if no kbrid passed in, then find first in toc
        this.rootnode = { nodes: this.state.item_toc };

        this._setParents(this.rootnode);
        this._setSelected(this.rootnode, this.kbrid);
        if (this.selectedNode) {
          this._setOpened(this.selectedNode);
          this._topicsArray.push(this.selectedNode);
        }
      }
      if (this.state.toc_open) {
        this.leftSideWidthPerc = this.state.global_screen_specs.tocWidthPercent;
        this.rightSideWidthPerc =
          this.state.global_screen_specs.topicWidthPercent;
      } else {
        this.leftSideWidthPerc = 0;
        this.rightSideWidthPerc = 100;
      }
      this.myRender();
    }
  }

  _setParents(node, parent) {
    node.open = false; //handy place to set this default status
    if (parent) {
      node.parent = parent;
    }
    if (node.nodes) {
      for (var i = 0; i < node.nodes.length; i++) {
        this._setParents(node.nodes[i], node);
      }
    }
  }

  _setSelected(node, href) {
    node.selected = false;
    if (node.href == href) {
      node.selected = true;
      this.selectedNode = node;
      this._setOpened(this.selectedNode);
    }
    if (node.nodes) {
      for (var i = 0; i < node.nodes.length; i++) {
        this._setSelected(node.nodes[i], href);
      }
    }
  }

  _setOpened(node) {
    node.open = true;
    if (node.parent) {
      this._setOpened(node.parent);
    }
  }

  _recurseToHREF(node) {
    if (node.href) {
      return node.href;
    }
    for (var i = 0; i < node.nodes; i++) {
      return this._recurseToHREF(node.nodes[i]);
    }
  }

  _handleTocItemClicked(e) {
    var node = e.detail;
    if (this._isCurrentItem(node.href)) {
      this.kbrid = node.href;
      if (this._topicsArray.includes(node)) {
        //scroll to after render
        this.scrollTo = node;
      } else {
        //load
        //this._topicsArray=[]
        this._topicsArray.push(node);
      }
      history.pushState(
        null,
        null,
        "/kb/" +
          this.state.langCode +
          "/" +
          this.state.item.item.externalId +
          this.kbrid
      );
      this._setSelected(this.rootnode, this.kbrid);
      storeInstance.dispatch("setState", {
        property: "selected_tocitem",
        value: node,
      });
    } else {
      var aTmp = node.href.split("_");
      if (aTmp.length > 0) {
        Router.go("/kb/" + this.state.langCode + "/" + aTmp[1] + node.href);
      }
    }
  }

  _autoLoad(node) {
    this._topicsArray.push(node);
    this.kbrid = node.href;
    history.pushState(
      null,
      null,
      "/kb/" +
        this.state.langCode +
        "/" +
        this.state.item.item.externalId +
        this.kbrid
    );
    this._setSelected(this.rootnode, this.kbrid);
    storeInstance.dispatch("setState", {
      property: "selected_tocitem",
      value: node,
    });
  }

  _handleTocTopicLinkClicked(e) {
    this._setSelected(this.rootnode, e.detail);
    storeInstance.dispatch("touch");
  }

  _isCurrentItem(href) {
    var aTmp = href.split("_");
    if (aTmp.length > 0) {
      if (aTmp[1] == this.state.item.item.externalId) {
        return true;
      }
    }
    return false;
  }

  myRender() {
    render(this.helpsetTemplate(), this.shadowRoot);
    if (!this.rightside) {
      this.rightside = this.shadowRoot.querySelector("#rightside");
      this._setScrollEvent();
    }
    if (!this.topicscontainer) {
      this.topicscontainer = this.shadowRoot.querySelector("#topicscontainer");
    }
    if (!this.helpsetcontainer) {
      this.helpsetcontainer =
        this.shadowRoot.querySelector("#helpsetcontainer");
      this.helpsetcontainer.addEventListener(
        "splitter-dragend",
        this.updateScreenWidthSpecs.bind(this)
      );
    } else {
      if (!this.state.toc_open) {
        var leftPx = 0;
        var rightPx = this.state.global_screen_specs.viewportWidth;
      } else {
        var leftPx = parseInt(
          this.state.global_screen_specs.viewportWidth * this.leftSideWidthPerc
        );
        var rightPx = parseInt(
          this.state.global_screen_specs.viewportWidth * this.rightSideWidthPerc
        );
      }
      this.helpsetcontainer.children[0].style.flex = "1 1 " + leftPx + "px";
      this.helpsetcontainer.children[1].style.flex = "1 1 " + rightPx + "px";
    }

    if (this.scrollTo) {
      var target = this.topicscontainer.querySelectorAll(
        "#" + this.scrollTo.href
      );
      if (target.length == 1) {
        var targetRect = target[0].getBoundingClientRect();
        this.helpsetcontainer.children[1].scrollTop = targetRect.top; //right side
        this.scrollTo = null;
      }
    }
  }

  _setScrollEvent() {
    // adding scroll event
    this.rightside.addEventListener(
      "scroll",
      function () {
        // detects new state and compares it with the new one
        if (document.body.getBoundingClientRect().top > this.scrollPos) {
          this.scrollDirection = "UP";
          document
            .getElementById("info-box")
            .setAttribute("data-scroll-direction", "UP");
        } else {
          this.scrollDirection = "DOWN";
          this.scrollPos = document.body.getBoundingClientRect().top;
        }
      }.bind(this)
    );
  }

  updateScreenWidthSpecs(e) {
    storeInstance.dispatch("setHelpsetLayoutWidths", {
      left: e.currentTarget.children[0].offsetWidth,
      right: e.currentTarget.children[1].offsetWidth,
    });
    storeInstance.dispatch("setState", {
      property: "toc_open",
      value: e.currentTarget.children[0].offsetWidth > 0,
    });
  }

  helpsetTemplate() {
    return html`
            <style>
                #leftside{
                    height: ${this.state.global_screen_specs.workspaceHeight}px;
                    overflow: auto;
                    width: ${this.leftSideWidthPerc}%;
                }
                #rightside{
                    height: ${this.state.global_screen_specs.workspaceHeight}px;
                    overflow: auto;
                    width: ${this.rightSideWidthPerc}%;
                    
                }
                #pagewrapper{
                    max-width:1024px;
                    padding: var(--block-padding);
                }
                #topicwrapper{
                    background-color: var(--kb-surface-color);
                    border: 1px solid black;
                    padding: var(--block-padding);
                    margin-top: var(--block-padding);
                    border: var(--kb-surface-border);
                    border: 2px solid grey;
                    border-radius: var(--kb-border-radius);
                }
                
                #topmarker{
                    /*border-top: 3px solid red;*/
                    position:fixed;
                    top: 100px;
                    width:100%;
                 }
                 #bottommarker{
                    /*border-top: 3px solid red;*/
                    position:fixed;
                    width:100%;
                    top: ${
                      this.state.global_screen_specs.viewportHeight - 100
                    }px;
                 }
                 .cover {
                    position: fixed;
                    top: 100px;
                    right: 0px;
                    bottom: 500px;
                    left: 0px;
                    /*background-color: hsla(30deg, 40%, 80%, 0.5);*/
                  }
            
            </style>

            <hr id="topmarker"> </hr>
            <hr id="bottommarker"> </hr>
                <div class='cover'></div>
            <vaadin-split-layout id="helpsetcontainer">
                <div id='leftside'>
                    <kb-toc .rootnode="${this.rootnode}" .kbrid="${
      this.kbrid
    }"></kb-toc>
                </div>
                <div id='rightside' >
                    <div id='pagewrapper'>
                        <div id='topicwrapper'>
                            <mil-intersection-observer @intersect="${this.isIntersecting.bind(
                              this,
                              "top"
                            )}" .thresholds="${[
      1.0,
    ]}" .root-margin="-100 0 0 0">
                            </mil-intersection-observer>
                            
                            <div id="topicscontainer">
                                ${this._topicsArray.map(
                                  (node) =>
                                    html`<kb-topic
                                      id="${node.href}"
                                      .node="${node}"
                                    ></kb-topic>`
                                )}
                            </div>

                            <mil-intersection-observer @intersect="${this.isIntersecting.bind(
                              this,
                              "bottom"
                            )}" .thresholds="${[1.0]}" >
                            </mil-intersection-observer>
                        </div>
                    </div>        
                </div>
            </vaadin-split-layout>`;
  }

  isIntersecting(marker, e) {
    if (
      marker == "top" &&
      (this.scrollDirection == "UP" || this.scrollDirection == "START")
    ) {
      var tmp = util.getPrevious(this._topicsArray[0]);
      if (tmp) {
        this._autoLoad(tmp);
      }
      this.scrollDirection = "";
    }
    if (
      marker == "bottom" &&
      (this.scrollDirection == "DOWN" || this.scrollDirection == "START")
    ) {
      var tmp = util.getNext(this._topicsArray[this._topicsArray.length - 1]);
      if (tmp) {
        this._autoLoad(tmp);
      }
      this.scrollDirection = "";
    }
  }

  _handleTopicScrolledIntoView(e) {
    var tmpNode = e.detail;
    if (tmpNode.href) {
      this.kbrid = tmpNode.href;
      history.pushState(
        null,
        null,
        "/kb/" +
          this.state.langCode +
          "/" +
          this.state.item.item.externalId +
          this.kbrid
      );
      this._setSelected(this.rootnode, this.kbrid);
    }
  }
}

customElements.define("kb-helpset-infinite", KbHelpsetInfinite);
